"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle, NumberDisplay, TextBody, TextDisplay, VisuallyHidden } from "@opensea/ui-kit";
import { Error } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { OFFER_MAX_DECIMALS } from "../../../constants";
export const CollectionOfferPriceWarningModal = t0 => {
  const $ = _c(63);
  const {
    open,
    onNext,
    setIsOpen,
    offerSymbol
  } = t0;
  const t = useTranslations("wallet.CollectionOfferPriceWarningModal");
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "offers"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const offers = useWatch(t1);
  let T0;
  let T1;
  let T2;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== offerSymbol || $[3] !== offers || $[4] !== t) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const highSevPriceWarnings = offers.filter(_temp);
      if (highSevPriceWarnings.length === 0) {
        t9 = null;
        break bb0;
      }
      const firstWarningOffer = highSevPriceWarnings[0];
      T2 = Modal;
      let t10;
      if ($[16] !== t) {
        t10 = t("title");
        $[16] = t;
        $[17] = t10;
      } else {
        t10 = $[17];
      }
      if ($[18] !== t10) {
        t8 = <ModalHeader><VisuallyHidden><ModalHeaderTitle>{t10}</ModalHeaderTitle></VisuallyHidden></ModalHeader>;
        $[18] = t10;
        $[19] = t8;
      } else {
        t8 = $[19];
      }
      T1 = ModalBody;
      t5 = "flex-col items-center gap-3";
      if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <FlexCenter className="rounded-full bg-error-1-transparent-1 p-3"><Error fill="error-1" size={28} /></FlexCenter>;
        $[20] = t6;
      } else {
        t6 = $[20];
      }
      let t11;
      if ($[21] !== t) {
        t11 = t("highOfferPrice");
        $[21] = t;
        $[22] = t11;
      } else {
        t11 = $[22];
      }
      if ($[23] !== t11) {
        t7 = <TextDisplay size="sm">{t11}</TextDisplay>;
        $[23] = t11;
        $[24] = t7;
      } else {
        t7 = $[24];
      }
      T0 = TextBody;
      t2 = "text-center text-secondary";
      t3 = "md";
      t4 = t.rich("warningMessage", {
        price: () => <NumberDisplay className="text-text-primary" suffix={offerSymbol} value={firstWarningOffer?.price} />,
        floorPrice: () => <NumberDisplay className="text-text-primary" suffix={offerSymbol} value={firstWarningOffer?.floorPrice && bn(firstWarningOffer.floorPrice).decimalPlaces(OFFER_MAX_DECIMALS)} />
      });
    }
    $[2] = offerSymbol;
    $[3] = offers;
    $[4] = t;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[25] !== T0 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4) {
    t10 = <T0 className={t2} size={t3}>{t4}</T0>;
    $[25] = T0;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== T1 || $[31] !== t10 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7) {
    t11 = <T1 className={t5}>{t6}{t7}{t10}</T1>;
    $[30] = T1;
    $[31] = t10;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== setIsOpen) {
    t12 = () => {
      setIsOpen(false);
    };
    $[36] = setIsOpen;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t) {
    t13 = t("cancel");
    $[38] = t;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t12 || $[41] !== t13) {
    t14 = <ModalFooterButton onClick={t12} variant="secondary">{t13}</ModalFooterButton>;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== onNext || $[44] !== setIsOpen) {
    t15 = () => {
      setIsOpen(false);
      onNext();
    };
    $[43] = onNext;
    $[44] = setIsOpen;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t) {
    t16 = t("confirmOfferPrice");
    $[46] = t;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== t15 || $[49] !== t16) {
    t17 = <ModalFooterButton onClick={t15}>{t16}</ModalFooterButton>;
    $[48] = t15;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== t14 || $[52] !== t17) {
    t18 = <ModalFooter>{t14}{t17}</ModalFooter>;
    $[51] = t14;
    $[52] = t17;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  let t19;
  if ($[54] !== t11 || $[55] !== t18 || $[56] !== t8) {
    t19 = <>{t8}{t11}{t18}</>;
    $[54] = t11;
    $[55] = t18;
    $[56] = t8;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] !== T2 || $[59] !== open || $[60] !== setIsOpen || $[61] !== t19) {
    t20 = <T2 content={t19} onOpenChange={setIsOpen} open={open} />;
    $[58] = T2;
    $[59] = open;
    $[60] = setIsOpen;
    $[61] = t19;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  return t20;
};
function _temp(offer) {
  return offer?.shouldConfirmPrice;
}